// extracted by mini-css-extract-plugin
export default {"card-header":"UserAccount_card-header__HsYWl","account-row":"UserAccount_account-row__ejxCk"};